// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"Map_blockWrapper__jC7aY","content":"Map_content___94Wb","mapWrapper":"Map_mapWrapper__m6q4U"};